/* import __COLOCATED_TEMPLATE__ from './contact-background.hbs'; */
import Component from '@glimmer/component';
import styles from './contact-background.module.scss';

export default class ContactContactBackground extends Component {
  styles = styles;
}
